// extracted by mini-css-extract-plugin
export default {"container":"styles_container__g4nL6","card":"styles_card__FZHRU"};